import type { MRT_Cell } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import type { WOManufacturerMatchStore } from '../wo-manufacturer-match/wo-manufacturer-match-store'
import type { APIModelAliasReference } from '@visorpro/client'

export interface RegisteredModelCellProps {
    cell: MRT_Cell<APIModelAliasReference, any>
    store: WOManufacturerMatchStore
}

export const InputManufacturerCell = observer<RegisteredModelCellProps>(
    ({ cell }) => {
        return <div>{cell.row.original.input_manufacturer}</div>
    },
)
